"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "FONT_FAMILIES", {
  enumerable: true,
  get: function get() {
    return _constants.FONT_FAMILIES;
  }
});
Object.defineProperty(exports, "HEIGHTS", {
  enumerable: true,
  get: function get() {
    return _constants.HEIGHTS;
  }
});
Object.defineProperty(exports, "SIZES", {
  enumerable: true,
  get: function get() {
    return _constants.SIZES;
  }
});
Object.defineProperty(exports, "THEMES", {
  enumerable: true,
  get: function get() {
    return _constants.THEMES;
  }
});
Object.defineProperty(exports, "WIDTHS", {
  enumerable: true,
  get: function get() {
    return _constants.WIDTHS;
  }
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames2 = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _RenderWhen = _interopRequireDefault(require("../../RenderWhen"));
var _styles = _interopRequireDefault(require("./styles"));
var _constants = require("./constants");
var _templateObject;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
var DEFAULT_APP_THEME = _constants.THEMES.PURPLE;
var StyledButton = _styledComponents.default.button(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    background: ", ";\n  path {\n      fill: ", " !important;\n  }\n  :hover {\n      filter: brightness(", ");\n    background: ", " !important;\n    color: ", ";\n\n    :hover path {\n      fill: ", ";\n    }\n  }\n"])), function (props) {
  return props.ownTheme === DEFAULT_APP_THEME ? props.theme.button.background : props.background;
}, function (props) {
  return props.activeIcon ? props.theme.primaryColor : undefined;
}, function (props) {
  return props.activeIcon ? '120%' : '100%';
}, function (props) {
  return props.activeTheme === DEFAULT_APP_THEME && !props.onlyIcon ? props.theme.button.background : props.background;
}, function (props) {
  return props.activeColor ? props.theme.primaryColor : undefined;
}, function (props) {
  return props.activeTheme === DEFAULT_APP_THEME ? props.theme.primaryColor : undefined;
});
var Button = (0, _react.forwardRef)(function (_ref, ref) {
  var activeColor = _ref.activeColor,
    _ref$activeIcon = _ref.activeIcon,
    activeIcon = _ref$activeIcon === void 0 ? false : _ref$activeIcon,
    activeTheme = _ref.activeTheme,
    className = _ref.className,
    _ref$circle = _ref.circle,
    circle = _ref$circle === void 0 ? false : _ref$circle,
    children = _ref.children,
    contentClassName = _ref.contentClassName,
    background = _ref.background,
    disabled = _ref.disabled,
    _ref$fontFamily = _ref.fontFamily,
    fontFamily = _ref$fontFamily === void 0 ? _constants.FONT_FAMILIES.BOLD : _ref$fontFamily,
    height = _ref.height,
    icon = _ref.icon,
    iconClassName = _ref.iconClassName,
    id = _ref.id,
    _ref$loading = _ref.loading,
    loading = _ref$loading === void 0 ? false : _ref$loading,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? _constants.SIZES.MEDIUM : _ref$size,
    title = _ref.title,
    _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? _constants.THEMES.WHITE : _ref$theme,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'button' : _ref$type,
    width = _ref.width,
    onClick = _ref.onClick,
    onMouseEnter = _ref.onMouseEnter,
    onMouseLeave = _ref.onMouseLeave;
  return /*#__PURE__*/_react.default.createElement(StyledButton, {
    activeColor: activeColor,
    activeTheme: activeTheme,
    activeIcon: activeIcon,
    background: background,
    className: (0, _classnames2.default)(_styles.default.root, className, _styles.default["active-theme--".concat(activeTheme)], _styles.default["theme--".concat(theme)], _styles.default["size--".concat(size)], _styles.default["fontFamily--".concat(fontFamily)], _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, _styles.default.disabled, disabled), _styles.default.circle, circle), _styles.default.loading, loading), _styles.default.onlyIcon, !children), _styles.default["width--".concat(width)], !!width), _styles.default["height--".concat(height)], !!height)),
    id: id,
    onlyIcon: !children,
    ownTheme: theme,
    ref: ref,
    title: title,
    type: type,
    onClick: !disabled ? onClick : undefined,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave
  }, !loading && /*#__PURE__*/_react.default.createElement(_RenderWhen.default, {
    isTrue: true,
    limit: 2
  }, /*#__PURE__*/_react.default.createElement(_RenderWhen.default.If, {
    isTrue: Boolean(icon)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames2.default)(_styles.default.icon, iconClassName),
    dangerouslySetInnerHTML: !(0, _react.isValidElement)(icon) ? {
      __html: icon
    } : undefined
  }, (0, _react.isValidElement)(icon) ? icon : undefined)), /*#__PURE__*/_react.default.createElement(_RenderWhen.default.If, {
    isTrue: Boolean(children)
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _classnames2.default)(_styles.default.content, contentClassName)
  }, children))));
});
Button.propTypes = {
  activeIcon: _propTypes.default.bool,
  activeColor: _propTypes.default.oneOf(Object.values(_constants.THEMES)),
  activeTheme: _propTypes.default.oneOf(Object.values(_constants.THEMES)),
  background: _propTypes.default.string,
  children: _propTypes.default.any,
  circle: _propTypes.default.bool,
  className: _propTypes.default.string,
  contentClassName: _propTypes.default.string,
  disabled: _propTypes.default.bool,
  fontFamily: _propTypes.default.oneOf(Object.values(_constants.FONT_FAMILIES)),
  height: _propTypes.default.oneOf(Object.values(_constants.HEIGHTS)),
  icon: _propTypes.default.any,
  iconClassName: _propTypes.default.string,
  id: _propTypes.default.string,
  loading: _propTypes.default.bool,
  theme: _propTypes.default.oneOf(Object.values(_constants.THEMES)),
  title: _propTypes.default.string,
  type: _propTypes.default.string,
  width: _propTypes.default.oneOf(Object.values(_constants.WIDTHS)),
  onClick: _propTypes.default.func
};
var _default = exports.default = (0, _react.memo)(Button);